<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- formulario -->
    <v-row>
      <v-col
        sm="1"
        lg="2"
        class="hidden-xs-only"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              fixed
              exact
              color="primary"
              v-bind="attrs" 
              v-on="on" 
              @click="regresar"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </v-col>

      <!-- formulario -->
      <v-col 
        cols="12" 
        sm="10" 
        lg="8"
      >
        <v-card 
          outlined 
          elevation="2" 
          :loading="loadingForm"
        >
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Actualizar Perfil
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col 
                cols="12" 
                sm="10" 
                lg="8"
              >
                <v-form 
                  ref="form" 
                  v-model="form"
                >
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Perfil*"
                    maxlength="50"
                    counter
                    v-model.trim="perfil"
                    :rules="perfilReglas"
                  >
                  </v-text-field>

                  <v-textarea
                    outlined
                    rows="4"
                    label="Descripción"
                    v-model.trim="descripcion"
                  >
                  </v-textarea>

                  <v-btn
                    large
                    block
                    elevation="2"
                    color="primary"
                    class="mt-2 mb-6"
                    exact
                    @click="actualizar"
                  >
                    Actualizar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue'
export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    form: true,
    loadingForm: false,

    perfil: '',
    perfilReglas: [
      (v) => !!v || "Escriba un Perfil"
    ],

    descripcion: ''
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("editarPerfil", this.$route.params.id_perfil)
    .then((response) => {
      this.perfil       = response.perfil
      this.descripcion  = response.descripcion
    })
    .catch(() => {});     
  },
  
  methods: {
    actualizar() {
      if (this.$refs.form.validate()) {
        this.loadingForm = true

        const perfil = {
          id:           this.$route.params.id_perfil,
          perfil:       this.perfil[0].toUpperCase() + this.perfil.toLowerCase().substring(1),
          descripcion:  this.descripcion
        }

        this.$store.dispatch("actualizarPerfil", perfil)
        .then((response) => {
          if(response.status == "success") {
            this.loadingForm = false
            let message = response.message.split(',')

            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            setTimeout(() => {
              this.alert = false
              this.$router.replace({ name: "perfil-gestionar" })
            }, 2000)
          }
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";
            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {})
      }
    },

    regresar() {
      this.$router.back()
    }
  }
}
</script>